<div class="main_404">
    <img src="../../../assets/img/404.svg" title="404 not found" class="img-fluid" alt="404 image">
    <button class="btn btn-primary" type="button" (click)="goToLogin()"> {{LabelConstant.goBack}}
    </button>
</div>